import { useState } from "react";
import { useHistory } from "react-router";
import axios from "axios"
import { useUser } from "../../../providers/UserContext";
import { useValue } from "../../../providers/ValueContext";

import {
  Container,
  SizeContainer,
  Title,
  BackButton,
  ContainerFactory,
  ContainerButton,
  ContainerImgFactory,
  ImgFactory,
  TitleFactory,
  NotAvailable,
  Imgmessage,
} from "./style";

const SelectionFactory = () => {
  const [smallNotAvailable, setSmallNotAvailable] = useState(false);
  const [mediumNotAvailable, setMediumNotAvailable] = useState(false);
  const { jogo, user, industry } = useUser()
  const { setEntranceValue } = useValue()

  const history = useHistory();

  const small = () => {
    setSmallNotAvailable(!smallNotAvailable);
    setMediumNotAvailable(false);
  };
  const medium = () => {
    setMediumNotAvailable(!mediumNotAvailable);
    setSmallNotAvailable(false);
  };

  const big = () => {
    setMediumNotAvailable(false);
    setSmallNotAvailable(false);
    const data = {
      "aluguelMensal": 90000,
      "batata": 0,
      "codIndustria": industry?.industria,
      "codJogo": jogo?.jogo,
      "corteFrango": 0,
      "frangoCarcaca": 0,
      "funcCompras": 0,
      "funcControleQualidade": 0,
      "funcDiretorGeral": 0,
      "funcEncContabilidade": 0,
      "funcEncLogistica": 0,
      "funcEncRH": 0,
      "funcEncTesouraria": 0,
      "funcGestorAdm": 0,
      "funcGestorComercial": 0,
      "funcGestorFin": 0,
      "funcGestorLogistica": 0,
      "funcGestorProducao": 0,
      "funcOperador": 0,
      "funcVendedor": 0,
      "gerador": 0,
      "industriaConfig": 0,
      "investimentoInicial": 10000000,
      "investimentoSaldo": 0,
      "linguica": 0
    }

    axios.post(`${process.env.REACT_APP_BASE_URL}/industria/cadastrar`, data)
      .then(resposne => {

        if (resposne.data.sucesso) {
          axios.get(`${process.env.REACT_APP_BASE_URL}/industria/obter/${industry?.industria}`)
            .then(response => {
              localStorage.setItem('@App:industria', JSON.stringify(response.data));
              setEntranceValue(response?.data?.investimentoInicial)
            })
        }

      })

    history.push("/mountFactory");
  };

  return (
    <Container>
      <SizeContainer>
        <Title>Monte sua Fábrica</Title>
        <BackButton onClick={() => history.push("/home")} />
        <ContainerFactory>
          <ContainerButton>
            <ContainerImgFactory onClick={small}>
              <ImgFactory src="./images/small_factory.svg" />
              {smallNotAvailable ? (
                <NotAvailable>Indisponível</NotAvailable>
              ) : (
                <TitleFactory>Pequena</TitleFactory>
              )}
            </ContainerImgFactory>
          </ContainerButton>
          <ContainerButton>
            <ContainerImgFactory onClick={medium}>
              <ImgFactory src="./images/medium_factory.svg" />
              {mediumNotAvailable ? (
                <NotAvailable>Indisponível</NotAvailable>
              ) : (
                <TitleFactory>Média</TitleFactory>
              )}
            </ContainerImgFactory>
          </ContainerButton>
          <ContainerButton onClick={big}>
            <ContainerImgFactory>
              <ImgFactory src="./images/big_factory.svg" />
              <TitleFactory>grande</TitleFactory>
            </ContainerImgFactory>
          </ContainerButton>
        </ContainerFactory>
        <Imgmessage src="./images/message_type_factory.svg" />
      </SizeContainer>
    </Container>
  );
};
export default SelectionFactory;
